// import React from 'react';

// const RupeeSymbol = (): JSX.Element => {
//   return <span>&#8377;</span>;
// };

// export default RupeeSymbol;
import React from 'react';

interface RupeeSymbolProps {
  ariaHidden?: boolean;
  id?: string;
}

const RupeeSymbol = ({ ariaHidden, id }: RupeeSymbolProps): JSX.Element => {
  return <span id={id} {...(ariaHidden === true ? { 'aria-hidden': 'true' } : {})}>&#8377;</span>;
};

export default RupeeSymbol;

